import React, { Component } from 'react';
import classNames from 'classnames';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Grid, Row, Col, Panel, Button, Input, DropdownButton, MenuItem } from 'react-bootstrap';
import { InputField } from '../Common/inputField';
import { Field } from 'redux-form'
import ReactDataGrid from 'react-data-grid';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import {UI_HEIGHT} from '../Common/constants';
import ConfirmModal from 'Common/confirmModal';

class SetWeightModal extends Component {
  static contextTypes = {
    router: React.PropTypes.object
  };

  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,

      weights: {
        rows: [],
        sortColumn: null,
        sortDirection: null
      },
      selectedWeightIdx: 1,
      selectedWeight: '',
      confirmModalOpen: false,
    }
  }

  componentDidMount() {
    // this.props.setRows(-1);
    let tempWeights = this.props.rows;
    if(!tempWeights)
      tempWeights = [];

    if (tempWeights.length >= this.props.totalLoaded) {
      let newWeights = tempWeights.splice(0, parseInt(this.props.totalLoaded));
      newWeights.map(newWeight => {
        newWeight = {'Weight': newWeight.Weight || newWeight}
      })
      let weights = { ...this.state.weights, rows: newWeights };
      this.setState({ weights });
    } else {
      let temp = tempWeights.length
      for (var i = 0; i < (this.props.totalLoaded - temp); i++) {
        tempWeights.push({ 'Weight': 0 });
      }
      let weights = { ...this.state.weights, rows: tempWeights };
      this.setState({ weights });
    }


    // this.setState({weights});
    // this.props.fetchReceiveLineWeights(this.props.rowChosen);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.totalWeight !== this.props.totalWeight) {
      const { rows } = this.state.weights;
      const length = rows.length;
      let avgWeight = (parseFloat(nextProps.totalWeight || 0)) / (parseFloat(length) || 1);
      avgWeight = (Math.floor(avgWeight * 100) / 100).toFixed(2);
      const diff = (parseFloat(nextProps.totalWeight || 0)) - (avgWeight * length);
      rows.map(r => {
        r.Weight = avgWeight;
      });
      if (length > 0) {
        rows[length - 1].Weight = ((parseFloat(rows[length - 1].Weight || 0) + diff) || 0).toFixed(2);
      }
      this.setState({ weights: { rows } });
    }
    if (nextProps.salesOrderLineWeights && nextProps.salesOrderLineWeights != this.props.salesOrderLineWeights) {
      let tempWeights = [];

      nextProps.salesOrderLineWeights.map(weight => {
        tempWeights.push({ Weight: weight });
      });

      if (nextProps.salesOrderLineWeights.length >= this.props.totalLoaded) {
        let newWeights = tempWeights.splice(0, parseInt(this.props.totalLoaded));
        let weights = { ...this.state.weights, rows: newWeights };
        this.setState({ weights });
      } else {
        let temp = tempWeights.length
        for (var i = 0; i < (this.props.totalLoaded - temp); i++) {
          tempWeights.push({ 'Weight': 0 });
        }
        let weights = { ...this.state.weights, rows: tempWeights };
        this.setState({ weights });
      }
    }
  }

  fillWithLastValue() {
    let index = 0;
    let newWeights = {...this.state.weights};

    for (var i = 0; i < this.state.weights.rows.length; i++) {
      if ( this.state.weights.rows[i].Weight == 0 ) {
        index = i;
        break;
      }
    }

    if ( index > 0 ) {
      let fillValue = this.state.weights.rows[index - 1].Weight;

      for (var i = index; i < this.state.weights.rows.length; i++) {
        newWeights.rows[i].Weight = fillValue;
      }
      this.setState({ weights: newWeights });
    }
  }

  clearAllValues() {
    let newWeights = [...this.state.weights.rows];
    newWeights.map(row => {
      row.Weight = 0;
    });

    let weights = {...this.state.weights, rows: newWeights }
    this.setState({ weights })
  }

  handleImportOnClick = () => {
    const { importLine, rows } = this.props;
    const weights = [];
    if (importLine.match(/^[0-9]*\.?[0-9]+( [0-9]*\.?[0-9]+)*$/)) {
      const tempWeights = importLine.split(' ');
      tempWeights.map(weight => {
        weights.push({ Weight: parseFloat(weight).toFixed(2) });
      });
    }
    if (rows && rows.length !== weights.length) {
      alert('Import quantity does not match with receiving quantity, please check your import.');
    } else {
      this.setState({
        weights: {
          rows: weights,
        },
      });
    }
  }

  handleKeyPress = (event) => {
    if(event.charCode == 13 && this.state.selectedWeight){
      event.preventDefault();
      //ReactDOM.findDOMNode(this.refs[value].getRenderedComponent().myInput.refs.input).focus();
      const weights = {...this.state.weights};

      if(this.state.selectedWeightIdx === this.state.weights.rows.length){
        weights.rows[this.state.selectedWeightIdx-1].Weight = this.state.selectedWeight;
        this.setState({ selectedWeight: '', selectedWeightIdx: 0, weights})
      }else if(this.state.selectedWeightIdx){
        weights.rows[this.state.selectedWeightIdx-1].Weight = this.state.selectedWeight;
        this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1), weights})
      }else{
        this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1) }, () => { this.props.setRows(this.props.rowChosen, this.props.tableChosen, this.state.weights.rows); this.props.closeC(); });
      }
    } else if (event.charCode == 13 && this.state.selectedWeightIdx === 0){
      this.setState({ selectedWeight: '', selectedWeightIdx: (this.state.selectedWeightIdx+1) }, () => { this.props.setRows(this.props.rowChosen, this.props.tableChosen, this.state.weights.rows); this.props.closeC(); });
    }
  }

  handleChange = event => {
    this.setState({selectedWeight: event.target.value});
  }

  renderWeightsSubmit = () => {
      const confirmWeights = (this.state.selectedWeightIdx === 0) ? <Translate value="press_enter_to_confirm_weights" /> : '';
      return (
        <div>
          <Row style={{paddingLeft: '50px', paddingLeft: '50px'}}>
            <h3 style={{paddingLeft: '18px'}}><Translate value="set_weights" /></h3>
            <Col sm={1}><label style={{paddingTop: '3px'}}>{this.state.selectedWeightIdx||''}</label></Col>
            <Col sm={6}><Input type="number" name="selectedWeight" autoFocus value={this.state.selectedWeight} onChange={this.handleChange} disabled={this.state.needsDelete} onKeyPress={(event) => {
                  this.handleKeyPress(event)
              }} /></Col>
          </Row>
          <Col><span style={{ color:'green', paddingLeft:'28px' }}>{confirmWeights}</span></Col>
        </div>
      );
  }

  renderWeightInputs() {
    const { salesOrderLineWeightsIsLoading, salesOrderLineWeightsError } = this.props;
    if (salesOrderLineWeightsIsLoading && !salesOrderLineWeightsError) return <Spinner className="marginTopStyle" />
    else if (salesOrderLineWeightsError) return <div className="alert alert-danger">{JSON.stringify(salesOrderLineWeightsError) }</div>
      else {
      const getRows = () => {
          return Data.Selectors.getRows(this.state.weights);
      }

      const getSize = () => {
          return getRows().length;
      }

      const rowGetter = rowIdx => {
        const rows = getRows();
        return Object.assign({ Idx: rowIdx + 1 }, rows[rowIdx]);
      }

      // Handle the row select function

      const onRowSelect = rows => {
          let weights = {...this.state.weights, rows: rows};
          this.setState({ weights });
      }

      const onRowClick = (rowIdx, row) => {
        this.setState({selectedWeight: row.Weight, selectedWeightIdx: row.Idx});
      }

      const handleRowUpdated = e => {
          let rows = this.state.weights.rows.slice(0);
          Object.assign(rows[e.rowIdx], e.updated);
          let weights = { ...this.state.weights, rows: rows }
          this.setState({ weights });
      }

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
          var weights = Object.assign({}, this.state.weights, { sortColumn: sortColumn, sortDirection: sortDirection });
          this.setState({weights});
      }

      //Custom Formatter component

      const DateFormatter = React.createClass({
          render() {
              if (this.props.value) {
                let dateMap = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                let date = new Date(this.props.value)
                let index = dateMap.indexOf(date.toString().slice(4,3));
                let localDate = index + date.toString().slice(8, 6);
                return <span>{date.toString().slice(4, 15)}</span>;;
              }
              else return <span className="label label-danger">-</span>;
          }
      });

      // Column difinition

      const columns = [
        {
            key: 'Idx',
            name: <Translate value="idx" />,
          width: 30,
            resizable: true,
            filterable: true,
        },
        {
            key: 'Weight',
            name: <Translate value="weight" />,
            resizable: true,
            filterable: true,
            editable: true,
        },
      ];

      return (
          <Row>
            <Col sm={6}>
              <div style={{ maxWidth: '99%' }} id="SetReceiveWeightModal-dataGrid1">
              <ReactDataGrid
                style={{ height: '10%' }}
                onGridSort={handleGridSort}
                columns={columns}
                enableCellSelect
                rowHeight={25}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                minHeight={275}
                onRowUpdated={handleRowUpdated}
                onRowClick={onRowClick}
              />
              </div></Col>
            <Col sm={6}>
            <button className="btn btn-primary col-sm-11 buttonStyle"onClick={() => {this.fillWithLastValue()}}><Translate value="fill_with_latest_value" /></button>
            <br/>
            <br/>
            <button className="btn btn-danger col-sm-11 buttonStyle" onClick={() => {this.clearAllValues()}}><Translate value="clear_all_values" /></button>
            <br/>
            <br/>
            {this.renderWeightsSubmit()}
            </Col>
          </Row>
      )
  }
}
  checkIfEnteredWeightInWeightRange = (range, weights) => {
    let inRange = true;
    weights.map(el => {
      if (el.Weight > range.MaxWeigh || el.Weight < range.MinWight) {
        inRange = false
      }
    })
    return inRange;
  }

  proceeToSetWeight = () => {
    this.props.setRows(this.props.rowChosen, this.props.tableChosen, this.state.weights.rows); this.props.closeC(); 
  }

  handleSaveWeightClick = () => {
    const inRange = this.checkIfEnteredWeightInWeightRange(this.props.state[this.props.tableChosen].rows[this.props.rowChosen].Product_id.WeightRange, this.state.weights.rows);
    if(!inRange) {
      this.openConfirmModal();
    }else {
      this.proceeToSetWeight();
    }
  }

  handleModalConfirmClick = () => {
    this.proceeToSetWeight();
  }

  handleModalCancelClick = () => {
    this.closeConfirmModal();
  }

  openConfirmModal = () => {
    this.setState({
      confirmModalOpen: true
    })
  }

  closeConfirmModal = () => {
    this.setState({
      confirmModalOpen: false
    })
  }

  render() {
    const { closeC, valid, importLine } = this.props;

    return (
      <ContentWrapper>
        <hr />
        {this.renderWeightInputs()}
        <br />
        <Row>
          <Col sm={3}><label><Translate value="total_weight" /></label></Col>
          <Col sm={3}><Field name="TotalWeight" component={InputField} /></Col>
        </Row>
        <br />
        <Row>
          <Col sm={3}>
            <label><Translate value="import_line" /></label>
          </Col>
          <Col sm={7}>
            <Field name="importLine" component={InputField} />
          </Col>
          <Col sm={1}>
            <Button
              bsStyle='primary'
              disabled={!valid || !importLine}
              onClick={this.handleImportOnClick}
            >
              <Translate value="import" />
            </Button>
          </Col>
        </Row>
        <br />
        <Row>
          <button
            className="btn btn-primary col-sm-11 buttonStyle"
            disabled={!valid}
            onClick={this.handleSaveWeightClick}
          >
            <Translate value="save_weights" />
          </button>
        </Row>
        <br />
        <Row>
          <button className="btn btn-danger col-sm-11 buttonStyle" onClick={() => {this.props.closeC()}}><Translate value="discard_changes" /></button>
        </Row>
        <ConfirmModal 
          title='Confirm Modal'
          content={<Translate value='weight_not_in_range' />}
          isVisible={this.state.confirmModalOpen}
          onConfirm={this.handleModalConfirmClick}
          onCancel={this.handleModalCancelClick}
        />
      </ContentWrapper>
    )
  }
}

export default SetWeightModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/setReceiveWeightModal.jsx